import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height", "viewBox", "fill"];
const _hoisted_2 = ["stroke", "stroke-opacity"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'HeartIcon',
    props: {
        width: { default: 20 },
        height: { default: 18 },
        viewBox: { default: '0 0 20 18' },
        background: { default: 'none' },
        color: { default: 'white' },
        opacity: { default: 1 }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: _ctx.width,
                height: _ctx.height,
                viewBox: _ctx.viewBox,
                fill: _ctx.background
            }, [
                _createElementVNode("path", {
                    d: "M19 5.25C19 2.765 16.901 0.75 14.312 0.75C12.377 0.75 10.715 1.876 10 3.483C9.285 1.876 7.623 0.75 5.687 0.75C3.1 0.75 1 2.765 1 5.25C1 12.47 10 17.25 10 17.25C10 17.25 19 12.47 19 5.25Z",
                    stroke: _ctx.color,
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-opacity": _ctx.opacity
                }, null, 8, _hoisted_2)
            ], 8, _hoisted_1));
        };
    }
});
